"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var typings_1 = require("../typings");
var const_1 = require("../utils/const");
var util_1 = require("../utils/util");
var MtMetaData = /** @class */ (function () {
    function MtMetaData(project, version, tracker) {
        this.version = '';
        this.globalTags = {};
        this.runEnv = 'container';
        this.containerVersion = '';
        this.biz = '';
        this.project = project;
        this.version = version;
        this.tracker = tracker;
        var screen = window.screen;
        this.screen = screen ? screen.width + "x" + screen.height : '-';
        this.sdkVersion = '__VERSION__';
        this.ua = window.navigator.userAgent;
        this.uuid =
            util_1.getCookie('uuid') ||
                util_1.getCookie('unionid') ||
                util_1.getCookie('dpid') ||
                util_1.getCookie('_lxsdk_cuid') ||
                '';
        this.visitId = util_1.getVisitId();
        // 根据 UA 解析出容器版本
        this.containerVersion = util_1.getTitansVersion() || '';
        // 根据主文档是否包含 __ot__ 判断是否为离线包页面 https://km.sankuai.com/page/161989510
        this.biz = window.__ot__ ? 'titansx' : 'titansx-web';
    }
    MtMetaData.prototype.getInfo = function () {
        return tslib_1.__assign(tslib_1.__assign({}, this.globalTags), { project: this.project, screen: this.screen, sdkVersion: this.sdkVersion, version: this.version, ua: this.ua, uuid: this.uuid, visitId: this.visitId, pagePath: this.getPath(), pageOriginUrl: util_1.getPageUrl(), runEnv: this.runEnv, containerVersion: this.containerVersion, biz: this.biz });
    };
    MtMetaData.prototype.setTags = function (tags) {
        if (!tags || typeof tags !== 'object')
            return;
        this.globalTags = util_1.extend(this.globalTags, tags);
    };
    MtMetaData.prototype.getPath = function () {
        var _a;
        var plugin = this.tracker.getPlugin(typings_1.PLUGIN_NAME.PV);
        if (plugin && ((_a = plugin.config) === null || _a === void 0 ? void 0 : _a.spaMode) === typings_1.SPAMODE.HASH) {
            var hashQueryIndex = location.hash.indexOf('?');
            if (hashQueryIndex > -1) {
                return location.hash.slice(1, hashQueryIndex);
            }
            else {
                return location.hash.slice(1);
            }
        }
        return location.pathname;
    };
    MtMetaData.prototype.listenSPAPV = function () {
        var _this = this;
        // 当加载了 pv plugin spa 模式动态前端路由切换时，需要更新 visitId 用与统计异常率
        this.tracker.queue.on(const_1.SPA_PV, function () {
            _this.visitId = util_1.getVisitId();
        });
    };
    MtMetaData.prototype.get = function (name) {
        return this[name] || '';
    };
    return MtMetaData;
}());
exports.default = MtMetaData;
//# sourceMappingURL=mtMetaData.js.map